// extracted by mini-css-extract-plugin
module.exports = {"tl":"home-parallax-module--tl--37byI","tr":"home-parallax-module--tr--KDkBF","tr2":"home-parallax-module--tr2--20BbB"};